var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sme-success"},[_c('div',{staticClass:"_ml-56-0 _w-592"},[_c('h2',{staticClass:"h2",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{staticClass:"p1 _mt-16-8",domProps:{"innerHTML":_vm._s(_vm.subtitle)}})]),_c('img',{staticClass:"_w-488 _ml-81 _mobile-hidden",attrs:{"src":_vm.setImg(_vm.type)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }